
























































































import {Vue, Component} from 'vue-property-decorator';
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import TextField from "@/components/inputs/TextField.vue";
import EForm from "@/components/datatable/EForm.vue";
import Id from "@/components/inputs/Id.vue";
import {store} from "@/store";

class DavaTuru {
  dava_turleri_id!: number;
  uyap_dava_tur_id!: string;
  aciklama!: string;
  dosya_turu!: string;
  eklenme_tarihi!: string;
  harca_dahilmi!: string;
  /** DB sütunu: `indexlendi` — backend POST alanı ile aynı olmalı */
  indexlendi!: string;
  seviye_parent_id!: string;
  soru_goster!: string;
  seriye_goster_mi!: string;
}

@Component({
  components: {Id, EForm, TextField, DeleteButton},
})
export default class DavaTurleri extends Vue {
  get store() {
    return store;
  }

  /** admin/koklu_davalar isteği yok — liste zaten `dava_turleri` ile yüklü */
  get parentSelectItems(): { text: string; value: string }[] {
    const head = { text: '— (kök seviye)', value: '0' };
    const selfId = this.formData.dava_turleri_id;
    const rest = this.items
        .filter((r: DavaTuru) => !selfId || String(r.dava_turleri_id) !== String(selfId))
        .map((r: DavaTuru) => ({ text: r.aciklama as string, value: String(r.dava_turleri_id) }));
    return [head, ...rest];
  }

  dialog: boolean = false;
  formAction: string = this.$store.state.arbApiUrl + 'admin/dava_turu';
  formData = new DavaTuru();
  formTitle: string = "";
  loading: boolean = true;
  headers = [
    {text: "ID", value: "dava_turleri_id"},
    {text: "UYAP Dava Tür ID", value: "uyap_dava_tur_id"},
    {text: "Açıklama", value: "aciklama"},
    {text: "Dosya Türü", value: "dosya_turu"},
    {text: "Kayıt Tarihi", value: "eklenme_tarihi"},
    {text: "İşlemler", value: "actions", sortable: false}
  ];
  items: DavaTuru[] = [];
  search = "";

  dosyaTuruOptions = [
    {text: "Arabuluculuk", value: "2"},
    {text: "Dava", value: "1"},
  ];

  mounted() {
    this.loadItems();
  }

  async loadItems() {
    try {
      this.loading = true;
      const response = await this.$http.get(this.$store.state.arbApiUrl + 'admin/dava_turleri');
      if (response.data && Array.isArray(response.data)) {
        this.items = response.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        this.items = response.data.data;
      } else {
        this.items = [];
      }
    } catch (e) {
      console.error('HATA ---: ', e);
    } finally {
      this.loading = false;
    }
  }

  editItem(item: DavaTuru) {
    this.formTitle = "Uyuşmazlık Türü Düzenle";
    const raw = item as any;
    this.formData = {
      ...item,
      seviye_parent_id: String(raw.seviye_parent_id ?? raw.seriye_parent_id ?? '0'),
      indexlendi: String(raw.indexlendi ?? raw.indekslendir ?? '0'),
    };
    this.formAction = this.$store.state.arbApiUrl + 'admin/dava_turu/' + item.dava_turleri_id;
    this.dialog = true;
  }

  onSeviyeParentInput(v: string | number | null) {
    const s = v == null || v === '' ? '0' : String(v);
    this.formData.seviye_parent_id = s;
  }

  addItem() {
    this.formTitle = "Yeni Uyuşmazlık Türü Ekle";
    const d = new DavaTuru();
    d.seviye_parent_id = '0';
    d.indexlendi = '0';
    d.soru_goster = '0';
    d.dosya_turu = '2';
    this.formData = d;
    this.formAction = this.$store.state.arbApiUrl + 'admin/dava_turu';
    this.dialog = true;
  }

  onSuccess() {
    this.loadItems();
    this.dialog = false;
  }
}
